import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core'
import { UserAgentService } from 'src/app/singleton-services/user-agent.service'

interface ImageWidths {
  [key: string]: {
    desktopWidth: number
    mobileWidth: number
  }
}

@Component({
  selector: 'flo-logos-display',
  templateUrl: './logos-display.component.html',
  styleUrls: ['./logos-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogosDisplayComponent implements OnInit {
  @Input()
  imageUrls: string[]

  constructor(private cdr: ChangeDetectorRef, private ua: UserAgentService) {}

  public isMobile = this.ua.userAgent.isMobile
  public normalizedImageWidths: ImageWidths = {}
  public MAX_LOGOS = 10
  public MIN_LOGOS = 3
  public DESKTOP_WIDTH_BASE = 74
  public MOBILE_WIDTH_BASE = 53

  ngOnInit(): void {
    this.imageUrls?.forEach((url: string) => {
      const img = new Image()
      img.src = url
      img.onload = () => {
        this.adjustImageWidth(img)
      }
    })
  }

  adjustImageWidth(image: HTMLImageElement): void {
    const desktopWidthBase = this.DESKTOP_WIDTH_BASE
    const mobileWidthBase = this.MOBILE_WIDTH_BASE
    const scaleFactor = 0.525 // Balance between height and width deltas of logos
    const imageRatio = image.naturalWidth / image.naturalHeight

    const width = Math.pow(imageRatio, scaleFactor) * desktopWidthBase
    const mobileWidth = Math.pow(imageRatio, scaleFactor) * mobileWidthBase

    this.normalizedImageWidths[image.src] = {
      desktopWidth: width,
      mobileWidth
    }
    this.cdr.detectChanges()
  }

  getNormalizedImageWidth(imageUrl: string): number {
    const widths = this.normalizedImageWidths[imageUrl]
    if (!widths) {
      return this.isMobile ? this.MOBILE_WIDTH_BASE : this.DESKTOP_WIDTH_BASE // Default values to avoid errors
    }
    return this.isMobile ? widths.mobileWidth : widths.desktopWidth
  }
}
